import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-venue-accomodation',
  templateUrl: './venue-accomodation.component.html',
  styleUrls: ['./venue-accomodation.component.css']
})
export class VenueAccomodationComponent24 implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
